import { useCallback, useMemo } from "react";
import { useUser } from "../context/UserContext";

const normalize = (value: string) =>
  value.replace(/\s+/g, "").toLowerCase();

export const usePermission = () => {
  const { user } = useUser();

  const permissions = useMemo(() => user?.role?.models ?? [], [user]);

  const getPermission = useCallback(
    (model: string) =>
      permissions.find(
        (item) => normalize(item.model) === normalize(model)
      ),
    [permissions]
  );

  const canView = (model: string) => Boolean(getPermission(model)?.view);
  const canCreate = (model: string) => Boolean(getPermission(model)?.create);
  const canEdit = (model: string) => Boolean(getPermission(model)?.edit);
  const canDelete = (model: string) => Boolean(getPermission(model)?.delete);

  return {
    canView,
    canCreate,
    canEdit,
    canDelete,
  };
};